import React from 'react';
import { IFontStyles, Text, useTheme } from '@fluentui/react';

export enum BadgeSize {
    size16 = 0,
    size24 = 1,
    size32 = 2,
}

type Props = {
    type?: string;
    value: string | number;
    size?: BadgeSize;
    className?: string;
    color?: string;
    backgroundColor?: string;
};

const Badge = (props: Props): JSX.Element => {
    const theme = useTheme();
    let circleSize, variant: keyof IFontStyles;

    switch (props.size) {
        case BadgeSize.size16: {
            circleSize = 16;
            variant = 'tiny';
            break;
        }
        case BadgeSize.size32: {
            circleSize = 32;
            variant = props.value && `${props.value}`.length >= 3 ? 'small' : 'medium';
            break;
        }
        default: {
            circleSize = 24;
            variant = 'small';
            break;
        }
    }

    const circleStyles: React.CSSProperties = {
        fontWeight: 'bold',
        background: props.backgroundColor ? props.backgroundColor : theme.palette.neutralLight,
        height: circleSize,
        width: circleSize,
        fontSize: variant,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const pillStyles: React.CSSProperties = {
        background: props.color ? props.color : theme.palette.neutralLight,
        padding: '0 15px',
        borderRadius: 15,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    return (
        <div style={props.type === 'pill' ? pillStyles : circleStyles} className={props.className}>
            <Text variant={variant} style={{ color: props.color ? props.color : theme.palette.black }}>
                {props.value}
            </Text>
        </div>
    );
};

export default Badge;
